const Footer = () => (
  <footer className="w-full py-10 text-center text-slate-400 dark:text-slate-500 text-sm mt-auto border-t border-slate-200 dark:border-slate-800">
    <p className="font-medium mb-1">
      <strong className="text-slate-600 dark:text-slate-300" translate="no">VidBatch</strong>
      {' '}is a free browser-based batch video converter for MP4, MOV, WEBM, MKV, AVI, M4V and GIF.
    </p>
    <p className="text-xs">
      © {new Date().getFullYear()}{' '}
      <a
        href="https://trevisoft.dev"
        target="_blank"
        rel="noopener noreferrer"
        className="font-bold text-slate-600 dark:text-slate-300 hover:text-teal-600 dark:hover:text-teal-300 hover:underline underline-offset-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-500 rounded"
        translate="no"
      >
        TREVISOFT
      </a>
      . All rights reserved.
    </p>
  </footer>
);

export default Footer;
